import { Component, OnInit } from '@angular/core';
import {
  AbstractControl, FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { RegistrationService } from "../services/registration.service";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { UserDTO } from "../models/user-dto";
import { KeycloakService } from "keycloak-angular";
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registrationForm: FormGroup;
  private hidePassword: boolean = true;
  private hidePasswordConfirm: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private registrationService: RegistrationService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private keycloakService: KeycloakService,
    private location: Location
  ) {
  }

  get form() {
    return this.registrationForm.controls;
  }

  ngOnInit(): void {
    this.registrationForm = new FormGroup(
      {
        email: new FormControl('', [Validators.email, Validators.required]),
        password: new FormControl('', [
          Validators.required,
          Validators.min(3),
          // min 1 special character, min 1 uppercase letter, min 1 lowercase letter, min 1 numeric
          Validators.pattern('^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\\d]){1,})(?=(.*[\\W]){1,})(?!.*\\s).{6,}$'),
        ]),
        passwordConfirm: new FormControl('', [Validators.required]),
        otp: new FormControl('', [Validators.required]),
        role: new FormControl('', [Validators.required]),
        termsAndConditions: new FormControl('', [Validators.required, Validators.requiredTrue]),
        gdpr: new FormControl('', [Validators.required, Validators.requiredTrue]),
      },
      { validators: this.confirmPasswordValidatorFn }
    );

    this.route.queryParams.subscribe((params) => {
      console.log(params);
      params['otp'] ? this.setFormOTP(params['otp']) : null;
      params['email'] ? this.setFormEmail(params['email']) : null;
    });
  }

  login(): void {
    this.keycloakService.login({ redirectUri: environment.feUrl });
  }

  shouldHidePassword() {
    return this.hidePassword;
  }

  shouldHidePasswordConfirm() {
    return this.hidePasswordConfirm;
  }

  toggleHidePassword() {
    this.hidePassword = !this.hidePassword;
  }

  toggleHidePasswordConfirm() {
    this.hidePasswordConfirm = !this.hidePasswordConfirm;
  }

  confirmPasswordValidatorFn(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const passwordConfirm = control.get('passwordConfirm');
    return password?.value === passwordConfirm?.value ? null : { notMatched: true };
  }

  sendOTP() {
    const email = this.form['email'].value;
    const dto: UserDTO = new UserDTO(email, null, null, null, null);

    this.registrationService.sendOTP(dto).subscribe((val) => {
      this.successOTPNotification();
    }, error => {
      if (error) {
        this.errorNotification(error.error.message);
      }
    });
  }

  resendOTP() {
    const email = this.form['email'].value;
    const dto: UserDTO = new UserDTO(email, null, null, null, null);

    this.registrationService.resendOTP(dto).subscribe((val) => {
      this.successNewOTPNotification();
    }, error => {
      if (error) {
        this.errorNotification(error.error.message);
      }
    });
  }

  checkOTP() {
    const email = this.form['email'].value;
    const otp = this.form['otp'].value;
    const dto: UserDTO = new UserDTO(email, null, otp, null, null);

    this.registrationService.checkOTP(dto).subscribe((val) => {
      if (val) {
        this.validOTPNotification();
      } else {
        this.errorNotification("Codul OTP introdus este invalid");
      }
    }, error => {
      if (error) {
        this.errorNotification(error.error.message);
      }
    });
  }

  setFormOTP(code: string) {
    this.registrationForm.controls['otp'].setValue(code);
  }

  setFormEmail(email: string) {
    this.registrationForm.controls['email'].setValue(email);
  }

  register() {
    if (this.registrationForm.invalid) {
      return;
    }

    const email = this.form['email'].value;
    const otp = this.form['otp'].value;
    const password = this.form['password'].value;
    const role = this.form['role'].value;
    const termsAndConditions = this.form['termsAndConditions'].value;
    const gdpr = this.form['gdpr'].value;

    const dto: UserDTO = new UserDTO(email, password, otp, role, termsAndConditions, gdpr);

    this.registrationService.createAccount(dto).subscribe((val) => {
      this.successRegistrationotification();
    }, error => {
      if (error) {
        this.errorNotification(error.error.message);
      }
    });
  }

  successOTPNotification() {
    Swal.fire({
      title: ' ',
      text: 'Codul OTP a fost trimis pe adresa de email: ' + this.form['email'].value,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  successNewOTPNotification() {
    Swal.fire({
      title: ' ',
      text: 'Un nou cod OTP a fost trimis pe adresa de email: ' + this.form['email'].value,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  validOTPNotification() {
    Swal.fire({
      title: ' ',
      text: 'Codul OTP introdus este valid',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  successRegistrationotification() {
    Swal.fire({
      title: ' ',
      text: "Contul a fost creat cu succes!",
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Mergi la autentificare',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.keycloakService.login({ redirectUri: environment.feUrl });
      }
    })
  }

  errorNotification(message: string) {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    })
  }

  goBack() {
    this.location.back();
  }
}
